'use strict';

angular.module('mobilezuz')
    .service('NagishLi', ['$window', '$rootScope', 'Config', '$compile', NagishLi])

function NagishLi($window, $rootScope, Config, $compile) {
    this.init = init;

    function _initNagishLi() {
        if (!$window.$NagishLi)
        {
            var node = document.createElement('script');
            node.src = 'https://d226b0iufwcjmj.cloudfront.net/nagishli/nagishli.js?v=2'
            node.type = 'text/javascript';
            document.getElementsByTagName('head')[0].appendChild(node);
        }
    }

    function _setNagishLiPosition() {
        if ($window.moveNagishLi) {
            $window.moveNagishLi($window.nl_pos.toUpperCase());
        } else {
            setTimeout(_setNagishLiPosition, 500);
        }
    }

    function _addNagishCloseElem(nagishInnerCntr) {
        var nagishMenu = document.getElementById('NagishLiMenus');
        nagishInnerCntr = nagishInnerCntr || 0;

        //== check if an element exists, if not we will retry 5 times with 2 seconds timer
        if (nagishMenu) {
            //== Create a new element to inject to the Nagishli Menu
            var newNagishMenuElem = angular.element('<li class="close_nagish" ng-bind=":: \'nagish_close_component\' | translate"></li>');
            //== This element on Click will hide all Component
            newNagishMenuElem.bind('touchend', function() {

                //== We need to click to the icon to close the Component, the state is stored for refresh
                document.getElementById('NagishLiLogo').click();

                setTimeout(function() {
                    //== Hide the Componentt
                    angular.element(document.getElementById('NagishLiTag')).css('display', 'none');
                }, 500);
            });
            //== Appending the new menu item to the menu
            nagishMenu.appendChild(newNagishMenuElem[0]);

            //== we need to compile to see the text
            $compile(newNagishMenuElem)(angular.element(document.body).scope());

        } else if (nagishInnerCntr < 5) {
            setTimeout(function() {
                //== Retrying the process for 5 times if the Component is not loaded yet
                _addNagishCloseElem(nagishInnerCntr + 1);
            }, 500);
        }
    }

    function init() {
        Config.waitForInit().then(function () {
            if (!Config.retailer.isAccessibilityOn) {
                return;
            }

            $window.nl_lang = Config.language.culture === 'he' ? Config.language.culture : 'en'; // nagishli only supports he & en
            $window.nl_pos = 'b' + Config.language.direction[0];
            $window.nl_dir = 'https://d226b0iufwcjmj.cloudfront.net/nagishli/nl-files/'

            _initNagishLi();
            _addNagishCloseElem();
            _setNagishLiPosition($window.nl_lang);

            $rootScope.$on('config.language.set', function (event, language) {
                $window.nl_pos = 'b' + language.direction[0];
                _setNagishLiPosition();
            });
        });
    }
}